import './style.scss';
import { Slider } from '../../../js/components/Slider/Slider';

export default !function () {
  const wrapper = document.querySelector('.speakers-v1__wrapper');

  if (!wrapper) {
    return;
  }

  const list = wrapper.querySelector('.speakers-v1__list');
  const items = wrapper.querySelectorAll('.speakers-v1__item');
  const controls = wrapper.querySelector('.speakers-v1__controls');

  const options = {
    wrapper,
    lazy: true,
    settings: {
      slideClass: 'speakers-v1__item',
      wrapperClass: 'speakers-v1__list',

      pagination: {
        el: '.speakers-v1__count',
        currentClass: 'controls__current',
        type: 'fraction',
      },

      navigation: {
        nextEl: '.speakers-v1__arrow-next',
        prevEl: '.speakers-v1__arrow-prev'
      },
    },
    modules: ['pagination', 'navigation', 'a11y'],
    initCondition: {
      sm: items.length > 1 && !list.classList.contains('speakers-v1__list--one-child'),
      md: false
    },
    controls
  };

  new Slider(options).init();
}();
